export const useShowDocumentGradedState = (
  submittedDocument: SubmittedDocument
) => {

  if (submittedDocument.state != DocumentState.graded) return false;

  return (
    ([
      DocumentSubmissionType.keyWordOutline,
      DocumentSubmissionType.roughDraft,
    ].includes(submittedDocument.documentSubmissionType ?? DocumentSubmissionType.finalDraft) ||
      submittedDocument.allowFinalDraftGradedState == true) &&
    submittedDocument.documentGradedState != undefined
  );
};
